<div class="header-container">
	<div class="header-bar1">
		<div class="header-bar1-inner">
			<div class="header-logo">
				<a class="header-logo-link" [routerLink]="landingRoute" title="Return to homepage" aria-label="HSBC Logo">
					<img src="assets/images/masterbrand-logo.png" alt="HSBC">
				</a>
			</div>
			<div class="item-devider"></div>
			<div class="app-name">
				Digital Vault
			</div>
			<div class="header-right">
				<div id="logout-btn" (click)="userLogout()" tabindex=0 (keyup.enter)="$event.target.click()">Log off</div>
				<!-- <div class="item-devider"></div> -->
				<div class="username-inner" style="margin: 4px 0px; cursor: pointer;">
					<!-- <div class="left-boder"></div> -->
					<!-- <i id="header-refresh" class="pi pi-refresh" (click)="refresh()"></i> -->
					<deer-icon id="header-refresh" type="renew" (click)="refresh()" width="25px" height="25px" tabindex=0 (keyup.enter)="$event.target.click()" aria-label="Refresh"></deer-icon>
					<!-- <i id="header-refresh" class="icon icon-renew" (click)="refresh()" tabindex=0 (keyup.enter)="$event.target.click()" 
						aria-label="Refresh"></i> -->
				</div>
				<div class="item-devider"></div>				
				<div class="username" appClickOutside (clickOutside)="onClickOutside($event)">
					<!-- <div class="username-inner" style="margin: 5px 0px;">
						<deer-icon id="username-dropdown" type="down" (click)="showUsernameDropdown = !showUsernameDropdown" width="25px" height="25px"></deer-icon>
					</div> -->
					<!-- <div class="username-inner" style="margin: 4px 0px; cursor: pointer;">
						<deer-icon id="username-dropdown" type="down" (click)="showUsernameDropdown = !showUsernameDropdown" width="25px" height="25px"></deer-icon>
					</div> -->
					<div class="username-inner">
						<!-- <div class="node-name">{{[nodeTypes.HSS, nodeTypes.CUSTOMER, nodeTypes.BACK_OFFICE].indexOf(nodeType) > -1 ? displayName+'('+nodeName+')' : displayName}}</div>
						<div class="user-name">Last login: {{lastLogin}}</div> -->
						<div class="node-name">{{nodeName}}</div>
						<div class="user-name">{{displayName}}</div>
					</div>
					<!-- <div class="username-dropdown" *ngIf="showUsernameDropdown">
						<div class="dropdown-item help" (click)="showUsernameDropdown = false;navigateToHelp()">Help</div>
					</div> -->
				</div>
				<div class="item-devider"></div>
				<!-- <i class="icon icon-circle-help-solid" style="float: right;" (click)="navigateToHelp()" tabindex=0 (keyup.enter)="$event.target.click()" aria-label="Help"></i> -->
				<deer-icon id="header-help" type="help-circle-solid" (click)="navigateToHelp()" style="float: right; cursor: pointer;" width="25px" height="25px" tabindex=0 (keyup.enter)="$event.target.click()" aria-label="Help"></deer-icon>
				<!-- <i id="header-help" class="icon icon-circle-help-solid username-inner" style="margin: 4px 0px; cursor: pointer;" 
					tabindex=0 (keyup.enter)="$event.target.click()" aria-label="Help" (click)="navigateToHelp()"></i> -->
				<div class="item-devider"></div>
			</div>
		</div>
	</div>
	<div class="header-bar2" aria-label="Main menu">
		<div class="responsive-menu"><i (click)="showMenuItem=!showMenuItem;" class="pi pi-align-justify" style="color: #FFF;font-size: 2.214em;padding-top: 10px;padding-left: 5px;"></i></div>
		<ul class="header-bar2-inner" [ngClass]="{'show-menu-item': showMenuItem}" style="list-style-type: none; padding-left: 0px;">
			<li class="menu-item" *ngIf="[nodeTypes.HSS, nodeTypes.CUSTOMER, nodeTypes.BACK_OFFICE].indexOf(nodeType) > -1"  
				[ngClass]="{ 'active': activeRoute == routes.HOLD_TRANSACTIONS_HOLDINGS}" 
				(click)="routeNavigate(routes.HOLD_TRANSACTIONS_HOLDINGS, 'Holdings')" 
				tabindex=0 (keyup.enter)="$event.target.click()" 
				[attr.aria-current]="activeRoute == routes.HOLD_TRANSACTIONS_HOLDINGS ? 'page' : null">
				<a>{{appLabels.HOLDINGS}}</a>
			</li>
			<li class="menu-item" *ngIf="[nodeTypes.HSS, nodeTypes.CUSTOMER, nodeTypes.BACK_OFFICE].indexOf(nodeType) > -1" 
				[ngClass]="{'active' : [routes.BUY_TRANSACTIONS, routes.BUY_TRANSACTIONS_NEW, routes.BUY_TRANSACTIONS_UPLOADED, routes.BUY_TRANSACTIONS_APPROVED].indexOf(activeRoute) > -1}" 
				(click)="routeNavigate(routes.BUY_TRANSACTIONS, appLabels.BUY_TRANSACTIONS)" 
				tabindex=0 (keyup.enter)="$event.target.click()" 
				[attr.aria-current]="[routes.BUY_TRANSACTIONS, routes.BUY_TRANSACTIONS_NEW, routes.BUY_TRANSACTIONS_UPLOADED, routes.BUY_TRANSACTIONS_APPROVED].indexOf(activeRoute) > -1 ? 'page' : null">
				<a>{{appLabels.BUY_TRANSACTIONS}}</a>
			</li>
			<li class="menu-item" *ngIf="[nodeTypes.HSS, nodeTypes.CUSTOMER, nodeTypes.BACK_OFFICE].indexOf(nodeType) > -1" 
				[ngClass]="{'active' : [routes.SELL_TRANSACTIONS, routes.SELL_TRANSACTIONS_NEW, routes.SELL_TRANSACTIONS_PENDING, routes.SELL_TRANSACTIONS_APPROVED].indexOf(activeRoute) > -1}" 
				(click)="routeNavigate(routes.SELL_TRANSACTIONS, appLabels.SELL_TRANSACTIONS)" 
				tabindex=0 (keyup.enter)="$event.target.click()" 
				[attr.aria-current]="[routes.SELL_TRANSACTIONS, routes.SELL_TRANSACTIONS_NEW, routes.SELL_TRANSACTIONS_PENDING, routes.SELL_TRANSACTIONS_APPROVED].indexOf(activeRoute) > -1 ? 'page' : null">
				<a>{{appLabels.SELL_TRANSACTIONS}}</a>
			</li>
			<li class="menu-item" *ngIf="[nodeTypes.HSS, nodeTypes.CUSTOMER, nodeTypes.BACK_OFFICE].indexOf(nodeType) > -1" 
				[ngClass]="{ 'active': activeRoute == routes.SEC_MASTER}" 
				(click)="routeNavigate(routes.SEC_MASTER, appLabels.SEC_MASTER)" 
				tabindex=0 (keyup.enter)="$event.target.click()" 
				[attr.aria-current]="activeRoute == routes.SEC_MASTER ? 'page' : null">
				<a>{{appLabels.SEC_MASTER}}</a>
			</li>
			<li class="menu-item" *ngIf="[nodeTypes.ADMIN].indexOf(nodeType) > -1" 
				[ngClass]="{ 'active': activeRoute == routes.USERS}"
				(click)="routeNavigate(routes.USERS, 'Users')" 
				tabindex=0 (keyup.enter)="$event.target.click()" 
				[attr.aria-current]="activeRoute == routes.USERS ? 'page' : null">
				<a>Users</a>
			</li>
			<!-- <div class="menu-item" *ngIf="[nodeTypes.ADMIN].indexOf(nodeType) > -1" (click)="routeNavigate(routes.CREATE_CLIENT)" [ngClass]="{ 'active': activeRoute == routes.CREATE_CLIENT}">
				<a>Create Client</a>
			</div> -->
		</ul>
	</div>
</div>